import { ComputedRef, WritableComputedRef, Ref } from 'vue';
import { Meal } from '@ve/types';
import { ProductForHotelFilters } from '@ve/components/hotel/filters/common/store/types';
import useMealsReference from './useMealsReference';

export default ({
                    selectedMeals,
                    mealsRepository,
                    products,
                }: {
    selectedMeals: Ref<number[]>,
    mealsRepository: Ref<Meal[]>,
    products: Ref<ProductForHotelFilters[]>,
}): {
    selectedMealsText: ComputedRef<string>,
    moreThanOneMealAvailableOrSelected: ComputedRef<boolean>,
    allMealsChecked: WritableComputedRef<boolean>,
    mealsReference: ComputedRef<Meal[]>,
} => {
    const {
        selectedMealsText,
        moreThanOneMealAvailableOrSelected,
        allMealsChecked,
        mealsReference,
    } = useMealsReference({
        selectedMeals,
        mealsRepository,
        products,
    });

    return {
        selectedMealsText,
        moreThanOneMealAvailableOrSelected,
        allMealsChecked,
        mealsReference,
    };
};